<template>
  <CustomPanel ref="panel" :title="'输入坐标'" :contentStyle="contentStyle" :isTopLine="true" :closeOnPressEscape="false" class="AddPointByGis" v-show="visible" @onClose="onClose">
    <div class="content" slot="content">
      <el-form class="formContainer" :model="form" :rules="rules" ref="form" label-position="right">
        <el-form-item label="坐标系：" prop="type">
          <el-select  v-model="form.type" placeholder="请选择坐标系" class="attribute-item" @change="onChangePos">
            <el-option  v-for="item in coordinateType" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经度值：" prop="lon">
          <el-input class="attribute-item" v-model.trim="form.lon" placeholder="请输入" @change="onChangePos"></el-input>
        </el-form-item>
        <el-form-item label="纬度值：" prop="lat">
          <el-input class="attribute-item" v-model.trim="form.lat" placeholder="请输入" @change="onChangePos"></el-input>
        </el-form-item>
        <el-form-item label="高度值：" prop="height">
          <el-input class="attribute-item" v-model.trim="form.height" placeholder="请输入" @change="onChangePos">
            <div class="append-icon" slot="suffix">米</div>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer" slot="footer">
      <div class="right">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="onSubmit">确认</el-button>
      </div>
    </div>
  </CustomPanel>
</template>

<script>
import CustomPanel from '@/components/CustomPanel'
import * as ruleUtils from '@/utils/rules'
import coordtransform from 'coordtransform'
export default {
  name: 'AddPointByGis',
  components: {
    CustomPanel
  },
  data () {
    return {
      visible: false,
      contentStyle: {
        height: 'auto'
      },
      coordinateType: [
        { name: 'WGS-84', id: '1' },
        { name: '高德（火星）坐标', id: '2' },
        { name: '百度坐标', id: '3' }
      ],
      form: {
        type: '1',
        lon: undefined,
        lat: undefined,
        height: undefined
      },
      transformedLon: 0,
      transformedLat: 0,
      // 校验规则
      rules: {
        type: [
          { required: true, message: '请选择坐标系', trigger: 'blur' }
        ],
        lon: [
          { required: true, message: '请输入标注经度', trigger: 'blur' },
          { validator: ruleUtils.validateLongitude, trigger: 'blur' }
        ],
        lat: [
          { required: true, message: '请输入标注纬度', trigger: 'blur' },
          { validator: ruleUtils.validateLatitude, trigger: 'blur' }
        ],
        height: [
          { required: true, message: '请输入标注高度', trigger: 'blur' },
          { validator: ruleUtils.validateNumber, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    show () {
      this.visible = true
      this.$store.dispatch('setDrawState', true)
    },
    clear () {
      this.form = this.$options.data().form
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    onClose () {
      this.clear()
      this.$store.dispatch('setDrawState', false)
      this.visible = false
    },
    onChangePos () {
      if (this.form.type === '1') {
        this.transformedLon = this.form.lon
        this.transformedLat = this.form.lat
      } else if (this.form.type === '2') {
        const location = coordtransform.gcj02towgs84(this.form.lon, this.form.lat)
        this.transformedLon = location[0]
        this.transformedLat = location[1]
      } else if (this.form.type === '3') {
        let location = coordtransform.bd09togcj02(this.form.lon, this.form.lat)
        location = coordtransform.gcj02towgs84(location[0], location[1])
        this.transformedLon = location[0]
        this.transformedLat = location[1]
      }
    },
    async onSubmit () {
      await this.$refs.form.validate()
      const cart = Cesium.Cartesian3.fromDegrees(this.transformedLon, this.transformedLat, this.form.height)
      const entity = this.$cesiumPlus.viewer.entities.add({
        billboard: {
          image: require('@/libs/cesiumExtents/Assets/Images/marker.png'),
          color: Cesium.Color.RED
        },
        position: cart
      })
      this.$cesiumPlus.cameraManager.zoomToPosition(cart)
      this.$emit('drawEndMsg', { type: CesiumPlus.DrawMode.Marker, entity: entity })
      this.onClose()
    }
  }
}
</script>
<style lang="scss">
.AddPointByGis{
  .el-form-item__content{
    margin-left: 70px;
  }
  .formContainer{
    .el-form-item__error{
      margin-left: 10px;
    }
  }
}
</style>
<style lang="scss" scoped>
.AddPointByGis{
  .content {
    margin: 10px 0px;
    font-size: 12px !important;
    .formContainer{
      max-height: 380px;
      overflow-y: hidden;
      padding: 0 20px;
      .attribute-item {
        width: 190px;
      }
    }
  }
  .footer {
    width: 100%;
    height: 50px;
    background: rgba(255, 255, 255, 0.05) !important;
    border-radius: 0px 0px 4px 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    .left {
      width: 63px;
      display: flex;
      justify-content: space-between;
      img {
        cursor: pointer;
      }
    }
    .right {
      width: 100%;
      text-align: right;
      .el-button{
        width: 80px;
        height: 32px;
      }
    }
  }
}
</style>
